import { CategoryDto } from "@/__generated__/graphql";
import { CategoryDtoWithHref } from "../../_components/SITESEARCH/SearchSideFilters/types/CategoryDtoWithHref";

export function generateRecursiveHrefs(
  basePath = "",
  categories: CategoryDto[],
  maxDepth?: number,
  currentDepth = 0,
): CategoryDtoWithHref[] {
  return categories.map((category) => {
    // Construct the current href
    const currentHref = `${basePath}/${category.slug}`;

    // Check if we should go deeper based on maxDepth
    const children =
      (maxDepth === undefined || currentDepth < maxDepth) && category.children
        ? generateRecursiveHrefs(currentHref, category.children, maxDepth, currentDepth + 1)
        : [];

    // Return a new category object with href and potentially limited children
    return {
      ...category,
      href: currentHref,
      children: children,
    };
  });
}
